/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    PolicyNumberLabel: {
        id: 'cep.components.SgEndorsementInfo.PolicyNumberLabel',
        defaultMessage: 'Policy Number'
    },
    CoverLevelLabel: {
        id: 'cep.components.SgEndorsementInfo.CoverLevelLabel',
        defaultMessage: 'Cover Level'
    },
    TypeLevelLabel: {
        id: 'cep.components.SgEndorsementInfo.TypeLevelLabel',
        defaultMessage: 'Type Level'
    },
    StartDateLabel: {
        id: 'cep.components.SgEndorsementInfo.StartDateLabel',
        defaultMessage: 'Start Date'
    },
    DateOfChangeHeader: {
        id: 'cep.components.SgEndorsementInfo.DateOfChangeHeader',
        defaultMessage: 'Select date of change'
    },
    Today: {
        id: 'cep.components.SgEndorsementInfo.Today',
        defaultMessage: 'Today'
    },
    Tomorrow: {
        id: 'cep.components.SgEndorsementInfo.Tomorrow',
        defaultMessage: 'Tomorrow'
    },
    Other: {
        id: 'cep.components.SgEndorsementInfo.Other',
        defaultMessage: 'Other'
    },
    EffectiveChangeDateLabel: {
        id: 'cep.components.SgEndorsementInfo.EffectiveChangeDateLabel',
        defaultMessage: 'Select date - any day up to 30 days from now'
    },
    SelectAmendsHeader: {
        id: 'cep.components.SgEndorsementInfo.SelectAmendsHeader',
        defaultMessage: 'Select all required amends and press \'Continue\'.'
    },
    VehicleBoxTitle: {
        id: 'cep.components.SgEndorsementInfo.VehicleBoxTitle',
        defaultMessage: 'Your vehicle'
    },
    DriversBoxTitle: {
        id: 'cep.components.SgEndorsementInfo.DriversBoxTitle',
        defaultMessage: 'Drivers'
    },
    CoveragesBoxTitle: {
        id: 'cep.components.SgEndorsementInfo.CoveragesBoxTitle',
        defaultMessage: 'Additional Cover'
    },
    SelectedCoveragesListTitle: {
        id: 'cep.components.SgEndorsementInfo.SelectedCoveragesListTitle',
        defaultMessage: 'Add-ons included: '
    },
    NotSelectedCoveragesListTitle: {
        id: 'cep.components.SgEndorsementInfo.NotSelectedCoveragesListTitle',
        defaultMessage: 'Add-ons not included: '
    },
    VehicleInfoLabel: {
        id: 'cep.components.SgEndorsementInfo.VehicleInfoLabel',
        defaultMessage: 'Vehicle: '
    },
    VehicleMileageLabel: {
        id: 'cep.components.SgEndorsementInfo.VehicleMileageLabel',
        defaultMessage: 'Mileage: '
    },
    VehicleUseLabel: {
        id: 'cep.components.SgEndorsementInfo.VehicleUseLabel',
        defaultMessage: 'Use: '
    },
    VehicleParkingLabel: {
        id: 'cep.components.SgEndorsementInfo.VehicleParkingLabel',
        defaultMessage: 'Parking: '
    },
    VehicleModificationsLabel: {
        id: 'cep.components.SgEndorsementInfo.VehicleModificationsLabel',
        defaultMessage: 'Modifications: '
    },
    VoluntaryADExcessLabel: {
        id: 'cep.components.SgEndorsementInfo.VoluntaryADExcessLabel',
        defaultMessage: 'Voluntary Accidental Damage Excess: '
    },
    VehicleNoModificationsValue: {
        id: 'cep.components.SgEndorsementInfo.VehicleNoModificationsValue',
        defaultMessage: 'No'
    },
    VehicleCheckbox: {
        id: 'cep.components.SgEndorsementInfo.VehicleCheckbox',
        defaultMessage: 'Change vehicle information'
    },
    DriversCheckbox: {
        id: 'cep.components.SgEndorsementInfo.DriversCheckbox',
        defaultMessage: 'Add or remove driver'
    },
    CoveragesCheckbox: {
        id: 'cep.components.SgEndorsementInfo.CoveragesCheckbox',
        defaultMessage: 'Change or add cover'
    },
    ClaimsPromise: {
        id: 'cep.components.SgEndorsementInfo.ClaimsPromise',
        defaultMessage: 'Claims Promise'
    },
    NoPolicyChangeOnPolicyWithFutureBoundRenewals: {
        id: 'cep.components.SgEndorsementInfo.NoPolicyChangeOnPolicyWithFutureBoundRenewals',
        defaultMessage: 'As you have a pending policy change we are unable to make additional online changes until that takes effect. Please call us on {phoneNumber} and our Customer Service team will be happy to help.'
    },
    NoPolicyChangeOnCashChequePaymentPlan: {
        id: 'cep.components.SgEndorsementInfo.NoPolicyChangeOnCashChequePaymentPlan',
        defaultMessage: 'Sorry, we are unable to process policy changes online due to your chosen method of payment. Please call us on {phoneNumber} and our Customer Service team will be happy to help.'
    },
    NoPolicyChangeOnPolicyWithFutureRenewals: {
        id: 'cep.components.SgEndorsementInfo.NoPolicyChangeOnPolicyWithFutureRenewals',
        defaultMessage: 'As your insurance is due to renew in the next 30 days you are unable to make any online changes to your policy. If you would like to make a change or discuss your level of cover, please call us on {phoneNumber} and our Customer Service team will be happy to help.'
    },
    NoPolicyChangeOnPolicyWithScheduledPolicy: {
        id: 'cep.components.SgEndorsementInfo.NoPolicyChangeOnPolicyWithScheduledPolicy',
        defaultMessage: 'Sorry, we are unable to process policy changes online until your policy start date. Please call us on {phoneNumber} and our Customer Service team will be happy to help.'
    },
    NoPolicyChangeOnPolicyWithOutstandingPayment: {
        id: 'cep.components.SgEndorsementInfo.NoPolicyChangeOnPolicyWithOutstandingPayment',
        defaultMessage: 'As there is an outstanding overdue payment for this policy we are unable to process policy changes online. Please call us on {phoneNumber} and our Customer Service team will be happy to help.'
    },
    NoPolicyChangeOnHomeAndMotorHomePolicy: {
        id: 'cep.components.SgEndorsementInfo.NoPolicyChangeOnHomeAndMotorHomePolicy',
        defaultMessage: 'Unfortunately we can\'t make changes to your policy online at this time. If you would like to make a change or discuss your level of cover, please contact us via '
    },
    WebChatLink: {
        id: 'cep.components.SgEndorsementInfo.WebChatLink',
        defaultMessage: 'web chat.'
    },
    NoPolicyChangeOnSmiPolicy: {
        id: 'cep.components.SgEndorsementInfo.NoPolicyChangeOnSmiPolicy',
        defaultMessage: 'Unfortunately your policy doesn\'t allow you to make changes online at present. If you would like to make a change or discuss your policy, please call us on {phoneNumber} and our Customer Service team will be happy to help.'
    },
    NoPolicyChangeOnTravelPolicy: {
        id: 'cep.components.SgEndorsementInfo.NoPolicyChangeOnTravelPolicy',
        defaultMessage: 'Unfortunately your policy doesn’t allow you to make changes online at present, but we are working hard to make this available to you shortly.  If you would like to make a change or discuss your level of cover, please call us on {phoneNumber} and our Customer Service team will be happy to help.'
    },
    DefaultError: {
        id: 'cep.components.SgEndorsementInfo.DefaultError',
        defaultMessage: 'Sorry, an error occurred, we are unable to process policy changes online. You can try later or contact one of our agents.'
    },
    DisableMessageWithWebChatFirst: {
        id: 'cep.components.SgEndorsementInfo.DisableMessageWithWebChatFirst',
        // eslint-disable-next-line max-len
        defaultMessage: 'Unfortunately we can\'t make changes to your policy online at this time. If you would like to make a change or discuss your level of cover, please contact us via '
    },
    DisableMessageWithWebChatSecond: {
        id: 'cep.components.SgEndorsementInfo.DisableMessageWithWebChatSecond',
        defaultMessage: 'web chat.'
    },
    NoPolicyChangeOnSpmPolicy: {
        id: 'cep.components.SgEndorsementInfo.NoPolicyChangeOnSpmPolicy',
        defaultMessage: 'Unfortunately your policy doesn\'t allow you to make changes online at present. If you would like to make a change or discuss your policy, please call us on {phoneNumber} and our Customer Service team will be happy to help.'
    },
});
